import { array, bool, func, object, string } from 'prop-types';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import Tab from './Tab';
import reorderTabs from '../libs/reorderTabs';
import MenuHeaderInput from './MenuHeaderInput';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import DragIcon from '@mui/icons-material/DragHandle';
import sty from '../styles/Tabs.module.css';

/**
 * @component TabList
 * @param { Object } props
 * @param { string } props.groupId
 * @param { object } props.savingState
 * @param { object } props.savingHandler
 * @param { array } props.tabs
 * @param { boolean } props.isCheckAll
 * @param { array } props.groupTabs
 * @param { function } props.onCheck
 * @param { function } props.onCheckAll
 * @param { function } props.onHandle
 * @param { function } props.onSetTabs
 * @param { function } props.onToggle
 * @param { function } props.onMenu
 * @param { object } props.handleSubtab
 * @returns { JSX.Element }
 */
function TabList(props) {
	const onDragEnd = (result) => {
		if (!result.destination) return;
		const results = reorderTabs(props.groupTabs, result);
		props.onSetTabs(results);
	};

	return (
		<section className={sty.tab_list_section}>
			<section className={sty.tab_list_header}>
				<IconButton className={sty.hidden_icon}>
					<DragIcon />
				</IconButton>
				<IconButton className={sty.hidden_icon}>
					<DragIcon />
				</IconButton>
				<Checkbox
					className={sty.header_checkbox}
					sx={{ '&.Mui-checked': { color: 'var(--cl-common-white)' } }}
					checked={props.isCheckAll}
					onClick={(e) => props.onCheckAll(e.target.checked)}
				/>
				<MenuHeaderInput value="Name" />
				<MenuHeaderInput value="URL" />
				<MenuHeaderInput value="Description" />
				<MenuHeaderInput value="Order" />
			</section>
			<DragDropContext onDragEnd={onDragEnd}>
				<Droppable droppableId="tabs" direction="vertical">
					{(provided) => (
						<>
							<section ref={provided.innerRef} {...provided.droppableProps}>
								{props.groupTabs.map((tab, index) => (
									<Tab
										key={index}
										index={index}
										groupId={props.groupId}
										tab={tab}
										tabs={props.tabs}
										savingState={props.savingState}
										savingHandler={props.savingHandler}
										groupTabs={props.groupTabs}
										onCheck={props.onCheck}
										onHandle={props.onHandle}
										onToggle={props.onToggle}
										onMenu={props.onMenu}
										handleSubtab={props.handleSubtab}
									/>
								))}
							</section>
							{provided.placeholder}
							{props.groupTabs.length === 0 && (
								<div className={sty.empty}>-- No tab have been selected yet. --</div>
							)}
						</>
					)}
				</Droppable>
			</DragDropContext>
		</section>
	);
}

TabList.propTypes = {
	groupId: string,
	savingState: object,
	savingHandler: object,
	tabs: array,
	isCheckAll: bool,
	groupTabs: array,
	onCheck: func,
	onCheckAll: func,
	onHandle: func,
	onSetTabs: func,
	onToggle: func,
	onMenu: func,
	handleSubtab: object,
};

export default TabList;
